import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import QuickNav from '@/pages/home/components/QuickNav';
import Verdict from '@/pages/home/components/Verdict';
import AboutSection from '@/pages/home/components/AboutSection';
import ReliabilitySection from '@/pages/home/components/ReliabilitySection';
import SafetySection from '@/pages/home/components/SafetySection';
import VirusSection from '@/pages/home/components/VirusSection';
import AuthenticitySection from '@/pages/home/components/AuthenticitySection';
import FeedbackSection from '@/pages/home/components/FeedbackSection';
import RisksSection from '@/pages/home/components/RisksSection';
import TipsSection from '@/pages/home/components/TipsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import ClosingSection from '@/pages/home/components/ClosingSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <QuickNav />
        <Verdict />
        <AboutSection />
        <ReliabilitySection />
        <SafetySection />
        <VirusSection />
        <AuthenticitySection />
        <FeedbackSection />
        <RisksSection />
        <TipsSection />
        <FaqSection />
        <ClosingSection />
      </main>
      <Footer />
    </div>
  );
}